import { configureStore, combineReducers } from '@reduxjs/toolkit';
import rootReducer from './reducer';
import adminReducer from './modules/admin/reducer';
import partnerReducer from './modules/partner/reducer';
import proposalReducer from './modules/proposal/reducer';
import leadReducer from './modules/lead/reducer';
import projectReducer from './modules/project/reducer';
import contactRequestReducer from './modules/contactRequest/reducer';
// Combine the rootReducer and adminReducer
const combinedReducer = combineReducers({
  root: rootReducer,
  admin: adminReducer,
  partner: partnerReducer,
  proposal: proposalReducer,
  lead: leadReducer,
  project: projectReducer,
  contactRequest: contactRequestReducer
});

const store = configureStore({
  reducer: combinedReducer,
  
  // preloadedState:getPreloadedState()
});
// function onStateChange() {
//   saveToLocalStorage(store.getState());
// }
// store.subscribe(onStateChange);
export type AppDispatch = typeof store.dispatch;

export default store;
